import { render, staticRenderFns } from "./SignUpDialogForm.vue?vue&type=template&id=8cbb218e&scoped=true"
import script from "./SignUpDialogForm.vue?vue&type=script&lang=ts"
export * from "./SignUpDialogForm.vue?vue&type=script&lang=ts"
import style0 from "./SignUpDialogForm.vue?vue&type=style&index=0&id=8cbb218e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbb218e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCheckbox,VCol,VContainer,VForm,VRow,VTextField})
